import React from 'react'
import ScrollToTop from "react-scroll-to-top"

import ReactWhatsapp from "react-whatsapp";

import boxkhat66600 from "../images/Box Kha Segun 66600.jpg";
import boxkhatsegun64900 from "../images/Box Khat 64900 Segun.jpg";
import boxkhat66900 from "../images/Box Khat 66900.jpg";
import boxkhat77900 from "../images/Box Khat 77900.jpg";

import boxkhat64500 from "../images/Box Khat 64500.jpg"
import boxkhat64500new from "../images/Box Khat 64900 new photo.jpg"

import boxkhat69000 from "../images/Box Khat 69000.jpg"

import boxkhat66900new from "../images/Box Khat  66900 NEW.jpg";
import boxkhat114 from "../images/Box Khat 414.jpg";
import boxkhat63999segun from "../images/Box Khat 63999.jpg"
import boxkhat64900 from "../images/BOX KHAT 64900 new.jpg";

import boxkhat64900segunnew from "../images/Box Khat 64900 Segun khat.jpg";
import boxkha66500 from "../images/Box Khat 66500.jpg";
import BoxKhat68900rmwoody from "../images/Box Khat 68900 rmwoody.jpg";
import BoxKhat74900new from "../images/Box Khat 74900 new.jpg"

import BoxKhat65900segun from "../images/Box Khat, 65900.jpg";
import BoxSegunKhat64900 from "../images/Box Segun Khat 64900.jpg";
import BoxKhat68500 from "../images/Box Khat  68500.jpg";
import BOXKHAT64500 from "../images/BOX KHAT 64,500.jpg";

import BoxKhat62900TeakWoodSegun from "../images/Box Khat 62900 Teak Wood (Segun).jpg"
import BoxKhat65000 from "../images/Box Khat 65000.jpg";
import BoxKhat74900 from "../images/Box Khat 74900.jpg"
import BoxKhatHomeset from "../images/Box Khat Home set.jpg";
import boxkhatmahogany  from "../images/MEHEGONY 54900.jpg"


import Segun from "../images/Segun.jpg";
import Mahogany44900 from "../images/Hybrid Mehegony - 44900.jpg"
import segun67900 from "../images/Segun - 67900.jpg"
import Mahogany57900 from "../images/Mehoginy - 57900 3.jpg";


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'




function Boxkhat() {
    return (
        <div>
            <div className='back'>
                    <br />
                 <div className="album py-0">
                        <div className="container">
                          <div className='colortext'>
                            <h2> <b>Box Khat</b> Teak Wood (Segun / Hybrid Mahogany)</h2>
                          </div>
                        </div>
                      </div>
                            <ScrollToTop smooth top="100" color="Gray"/>
            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={boxkhat66600} className="card-img-top" alt="boxkhat66600"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                            <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 66,600/-</b></p>
                                            <div className='fonts'>
<p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>
 
                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div>                         
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={boxkhatsegun64900} className="card-img-top" alt="boxkhatsegun64900"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                                 <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 64,900/-</b></p>
                                                 <div className='fonts'>
                                                 <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>
    
                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div>                         
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={boxkhat66900} className="card-img-top" alt="boxkhat66900"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                                  <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 66,900/-</b></p>
                                                      <div className='fonts'>
                                                  <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div>                         
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={boxkhat77900} className="card-img-top" alt="boxkhat77900"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1" >Box Khat                                     </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                             <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 77,900/-</b></p>
                                                 <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div>                         
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={boxkhat64500} className="card-img-top" alt="boxkhat64500"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Hybrid Mahogany</p>
                                            <p className='mb-0' style={{color:"#0F293F"}}><b>Price: 44,900/-</b></p>
                                            <div className='fonts'>
<p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>
    
                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div>                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={boxkhat64500new} className="card-img-top" alt="boxkhat64500new"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Hybrid Mahogany</p>
                                                 <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 44,900/-</b></p>
                                                            <div className='fonts'>
                                                 <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div>

                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={boxkhatmahogany} className="card-img-top" alt="boxkhatmahogany"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Hybrid Mahogany</p>
                                                  <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 54,900/-</b></p>
                                                    <div className='fonts'>
                                                  <p style={{color:"#158C26"}} className='mb-0' >Full Box </p>
                                                
                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div>
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={boxkhat69000} className="card-img-top" alt="boxkhat69000"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1" >Box Khat                                     </h5>
                                                <p className="card-text mb-1">Hybrid Mahogany</p>
                                             <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 47,900/-</b></p>
                                                 <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div>                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
   <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={boxkhat66900new} className="card-img-top" alt="boxkhat66900"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                            <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 66,900/-</b></p>
   <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={boxkhat114} className="card-img-top" alt="boxkhat114"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                                 <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 64,900/-</b></p>
                                                    <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={boxkhat63999segun} className="card-img-top" alt="boxkhat63999segun"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                                  <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 63,999/-</b></p>
                                                     <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={boxkhat64900} className="card-img-top" alt="boxkhat64900"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1" >Box Khat                                     </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                             <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 64,900/-</b></p>
                                                <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

               <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={boxkhat64900segunnew} className="card-img-top" alt="boxkhat64900segunnew"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                            <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 67,900/-</b></p>
               <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={boxkha66500} className="card-img-top" alt="BoxKhat68900rmwoody"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                                 <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 66,500/-</b></p>
                                                                <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BoxKhat68900rmwoody} className="card-img-top" alt="boxkhat63999segun"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                                  <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 68,900/-</b></p>
                                                                 <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BoxKhat74900new} className="card-img-top" alt="BoxKhat74900new"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1" >Box Khat                                     </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                             <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 74,900/-</b></p>
                                                            <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
              <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={BoxKhat65900segun} className="card-img-top" alt="BoxKhat65900segun"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                            <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 65,900/-</b></p>
   <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BoxSegunKhat64900} className="card-img-top" alt="BoxSegunKhat64900"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                                 <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 64,800/-</b></p>
                                                    <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BoxKhat68500} className="card-img-top" alt="BoxKhat68500"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>

                                                <p className="card-text mb-1">Category - Mahogany

</p>
                                                  <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 68,500/-</b></p>
                                                     <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BOXKHAT64500} className="card-img-top" alt="BOXKHAT64500"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1" >Box Khat                                     </h5>
                                              
                                                <p className="card-text mb-1">Category - Mahogany</p>
                                             <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 54,900/-</b></p>
                                                <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={BoxKhat62900TeakWoodSegun} className="card-img-top" alt="BoxKhat62900TeakWoodSegun"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                            <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 26,900/-</b></p>
   <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Half Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BoxKhat65000} className="card-img-top" alt="BoxKhat65000"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                                 <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 65,000/-</b></p>

                                                    <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BoxKhat74900} className="card-img-top" alt="BoxKhat74900"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                                  <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 74,900/-</b></p>

                                                     <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={BoxKhatHomeset} className="card-img-top" alt="BOXKHAT64500"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1" >Box Khat                                     </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun)</p>
                                             <p className='mb-1' style={{color:"#0F293F"}}><b>Price: 67,900/-</b></p>
                                                <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
           

           <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>

                                                <img src={Segun} className="card-img-top" alt="BoxKhat64900Segun"/>

                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category -  Segun / Mahogany / Hybrid Mahogany</p>
                                            <p className='mb-1' style={{color:"#0F293F"}}><b>v Segun: 64900/-, Mahogany - 54900/-, Hybrid Mahogany - 44900/-</b></p>
   <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Half Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Mahogany44900} className="card-img-top" alt="Mahogany44900"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun) / Mahogany  </p>
                                                 <p className='mb-1' style={{color:"#0F293F"}}><b>Price: Segun - 64900/-, Mehoginy - 54900/-, Hybrid Mehegony - 44900/-</b></p>

                                                    <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                       <div className="card">
                                            <Zoom>
                                                <img src={segun67900} className="card-img-top" alt="segun67900"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1">Box Khat </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun) / Mehoginy </p>
                                                 <p className='mb-1' style={{color:"#0F293F"}}><b>Price: Segun - 67900/-, Mehoginy - 57900/-</b></p>
                                                    <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <div className="card">
                                            <Zoom>
                                                <img src={Mahogany57900} className="card-img-top" alt="Mahogany57900"/>
                                            </Zoom>
                                            <div className="card-body">
                                                <h5 style={{ color: "#C4810B" }} className="card-title mb-1" >Box Khat                                     </h5>
                                                <p className="card-text mb-1">Category - Teak Wood (Segun) / Mahogany</p>
                                             <p className='mb-1' style={{color:"#0F293F"}}><b>Price: Segun - 67900/-, Mehoginy - 57900/-</b></p>
                                                <div className='fonts'>
                                             <p style={{color:"#158C26"}} className='mb-0' >Full Box Hydraulic</p>

                                                 <p style={{color:"grey"}}><small> Delivery & All Fittings <b style={{color:"#521010"}}>Free</b> Upto 50KM</small></p>
                                                 </div> 
                                                <div className="d-flex justify-content-between align-items-center mb-0">
                                                    <a className='colorbutton me-2' href='tel: 9434692386'> Book Now</a>
                                                    <ReactWhatsapp number="++91 9434692386" className="colorbuttonwhatsapp" message="I am Interested"> Whatsapp </ReactWhatsapp>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <br />
            </div>
        </div>
    )
}

export default Boxkhat